import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import { PublishedFileDeleteCallable } from "@/action-dialog/callables";
import type { FileRecord } from "@cohesive/api-client";

export interface DeletePublishedFileParams {
  record: FileRecord;
  perform: () => void | Promise<void>;
}

/**
 * Gate single-record file deletes behind a published-file confirmation.
 * Non-published records run `perform` immediately with no dialog.
 */
export async function runDeletePublishedFileWorkflow(
  params: DeletePublishedFileParams,
): Promise<boolean> {
  const { record, perform } = params;

  if (!record.published) {
    await perform();
    return true;
  }

  return withActionDialogLock(() =>
    PublishedFileDeleteCallable.call({
      mutationFn: async (call) => {
        await perform();
        call.end(true);
      },
    }),
  );
}
